// NF-S2 (REVISION 1.1): My Projects API client. The api.js axios instance
// unwraps the payload (returns data directly).
import api from '../services/api';

export const getMyProjects = () => api.get('/my-projects');

// Returns a detail-grid-shaped, financial-free payload so the SHARED
// ProjectDetailPage component renders it in its viewerMode branch.
export const getMyProjectGrid = (id) => api.get(`/my-projects/${id}`);

// WBS-RETIRE — the three consultant per-action WBS clients
// (`patchWbsTaskState`, `createWbsTask`, `deleteWbsTask`) are gone;
// the server endpoints they used now answer 410 WBS_RETIRED. Nothing
// in production FE code called them post-ASGN-S3 (only test mocks).

// WBS-S3 — consultant batch save (WBS-only). Same envelope as the PM
// /save endpoint (ProjectSaveDto in, ProjectSaveResultDto out) so the
// existing buildSaveChunks + applySaveResult plumbing in
// ProjectDetailPage works unchanged in readOnly mode. Server rejects
// anything outside the WBS surface with 400 + code
// (ConsultantCannotEditCostedTask, ConsultantCannotEditRoles,
// ConsultantCannotEditProject, ConsultantCannotEditWbsDescription,
// NotAWbsTask, …), 403 for non-members, 409 VERSION_CONFLICT for
// stale clients.
export const saveMyProjectWbs = (projectId, payload) =>
  api.post(`/my-projects/${projectId}/save-wbs`, payload);
